import { Navbar, Footer } from "@/components/Layout";
import { useSeo } from "@/hooks/useSeo";
import { Construction } from "lucide-react";

export default function Services() {
  useSeo({
    title: "Skogstjänster — kommer snart",
    description: "Sidan för skogstjänster är under uppbyggnad och kommer snart.",
    path: "/skogstjanster",
  });

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="container flex flex-1 items-center justify-center py-20">
        <div className="mx-auto flex max-w-md flex-col items-center text-center">
          <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted">
            <Construction className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
          </div>
          <h1 className="mb-3 font-display text-2xl font-bold md:text-3xl">
            Sidan är under uppbyggnad
          </h1>
          <p className="text-muted-foreground">
            Vi arbetar för fullt med att färdigställa skogstjänster. Kom gärna tillbaka snart!
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
